module.exports = "https://static.zego.com/_next/static/images/hiw-telematics-icon-5ac9544a87c0678cf2fc9447ffe6e887.svg";